import { useMemo } from "react";

import {
  FRONTEND_STORAGE_KEYS,
  useGetStorageValueQuery,
} from "@js/apps/common/frontend-storage";
import {
  useEmployerId,
  useGetManagedEmployerQuery,
} from "@js/apps/employer/hooks";
import { isDaysFromTodayEqualOrHigher } from "@js/utils";

const DAYS_THRESHOLD = 2;

export const useShowAirAiTopBar = () => {
  const employerId = useEmployerId();
  const { data: employerProfile } = useGetManagedEmployerQuery();

  const {
    data: storedDate,
    isLoading,
    isError,
  } = useGetStorageValueQuery(
    { key: FRONTEND_STORAGE_KEYS.air_ai_top_bar_dismissed_at },
    { skip: !employerId },
  );

  const showAirAiTopBar = useMemo(() => {
    if (!employerProfile || isLoading || isError) {
      return false;
    }

    if (!storedDate || typeof storedDate !== "string") {
      return true;
    }
    const shouldDisplayTopBarAgain = isDaysFromTodayEqualOrHigher(
      storedDate,
      DAYS_THRESHOLD,
    );

    return shouldDisplayTopBarAgain;
  }, [isLoading, storedDate, employerProfile, isError]);

  return { showAirAiTopBar };
};
